var constants = {
  "INIT_DATA" : "INIT_DATA",
  "DETAIL_DATA" : "DETAIL_DATA",
  "DEPENDENCY_DATA" : "DEPENDENCY_DATA",
  "LICENSE_DATA" : "LICENSE_DATA",
  "ACTIVE_THEME" : "ACTIVE_THEME",
  "PULL_DATA" : "PULL_DATA",
  "PUSH_DATA" : "PUSH_DATA",
  "CLONE_DATA" : "CLONE_DATA",
  "SNAPSHOT_DATA" : "SNAPSHOT_DATA",
  "ERROR_MESSAGE" : "ERROR_MESSAGE",
  "ERROR_MESSAGE1" : "ERROR_MESSAGE1",
  "RESETPOPUP" : "RESETPOPUP",
  "UPDATES_DATA" : "UPDATES_DATA",
  "INSTALL_DATA" : "INSTALL_DATA",
  "PUSH_DIFF" : "PUSH_DIFF",
  "PULL_DIFF" : "PULL_DIFF",
  "VALIDATE_EMAIL_POPUP": "VALIDATE_EMAIL_POPUP",
  "CONFIRM_PUSH": "CONFIRM_PUSH",
  "CONFIRM_PULL": "CONFIRM_PULL",
  "PULL_BY_VERSION": "PULL_BY_VERSION",
  "CLONE_BY_VERSION": "CLONE_BY_VERSION",
  "SHARE_PACKAGE_POPUP": "SHARE_PACKAGE_POPUP",
  "REVOKE": "REVOKE",
  "REJECT_POPUP": "REJECT_POPUP",
  "REJECT_OFFENSIVE_POPUP": "REJECT_OFFENSIVE_POPUP",
  "SNAPSHOT_VERSION_POPUP": "SNAPSHOT_VERSION_POPUP",
  "CONFLICT_ERROR_POPUP": "CONFLICT_ERROR_POPUP",
  "SIGNUP_POPUP": "SIGNUP_POPUP",
  "ACTIVATEUSER_POPUP": "ACTIVATEUSER_POPUP",
  "CLONE_SUCCESS_POPUP": "CLONE_SUCCESS_POPUP",
  "CLONE_WARNING_POPUP": "CLONE_WARNING_POPUP",
  "SNAPSHOT_ERROR": "SNAPSHOT_ERROR",
  "PROVIDE_EMAIL_POPUP": "PROVIDE_EMAIL_POPUP",
  "VERIFY_EMAIL_POPUP": "VERIFY_EMAIL_POPUP",
  "LIST_OF_ACCOUNTS": "LIST_OF_ACCOUNTS",
  "TRANSFER_PACKAGE_POPUP": "TRANSFER_PACKAGE_POPUP",
  "TRANSFER_R_U_SURE_POPUP": "TRANSFER_R_U_SURE_POPUP",
  "TRANSFER_SUCCESS_POPUP": "TRANSFER_SUCCESS_POPUP",
  "TRANSFER_REVOKE_POPUP": "TRANSFER_REVOKE_POPUP",
  "TRANSFER_WARNING_DEPENDENCIES_POPUP": "TRANSFER_WARNING_DEPENDENCIES_POPUP",
  "UPDATE_PACKAGE_POPUP": "UPDATE_PACKAGE_POPUP",

  "SIGNIN_DATA": "SIGNIN_DATA",
  "SIGNIN_ERROR": "SIGNIN_ERROR",
  "SIGNUP_DATA": "SIGNUP_DATA",
  "SIGNUP_ERROR": "SIGNUP_ERROR",
  "FORGOT_ERROR": "FORGOT_ERROR",
  "CLEAR_LOGIN_ERRORS": "CLEAR_LOGIN_ERRORS",
  "ACTIVEUSER_ERROR": "ACTIVEUSER_ERROR",
  "FORGOT_PASSWORD_POPUP": "FORGOT_PASSWORD_POPUP"
};

module.exports = constants;



/** WEBPACK FOOTER **
 ** ./html/constants.js
 **/